/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* ================ NOTIFICATIONS ============= */
var App = (function(){
	// Modal module
	var Modal = {};

	Modal.queue = [];

	Modal.element = null;

	Modal.show = function() {
		// Do we have an active modal?
		// If so, lets wait our turn
		if (Modal.element != null) {
			return false;
		}

		// Do we have any requests in the queue?
		// If not, lets just wait until we have some to show
		if (Modal.queue.length == 0) {
			return false;
		}

		// If we've reached this far that means we're first in line
		// You may proceed with the dialog
		var modal = $(Modal.queue.shift());

		// Add modal type-specific event handling
		if (modal.data('type') == 'alert') {
			var callback, confirmCallback;

			callback = modal.data('callback');

			confirmCallback = function(e) {
				Modal.hide();
				callback(true);
				e.preventDefault();
			};

			// Click events
			modal.find('button[data-action="confirm"]').on('click', confirmCallback);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if(e.which == 13) { confirmCallback(e); }
			});
		}

		if (modal.data('type') == 'confirmation') {
			var callback, confirmCallback, cancelCallback;

			callback = modal.data('callback');

			confirmCallback = function(e) {
				Modal.hide();
				callback(true);
				e.preventDefault();
			};

			cancelCallback = function(e) {
				Modal.hide();
				callback(false);
				e.preventDefault();
			};

			// Click events
			modal.find('button[data-action="confirm"]').on('click', confirmCallback);
			modal.find('button[data-action="cancel"]').on('click', cancelCallback);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if(e.which == 13) { confirmCallback(e); }

				// Escape key
				if(e.which == 27) { cancelCallback(e); }
			});
		}

		if (modal.data('type') == 'window') {
			var buttons, header, content, footer, iframe, updateDialog;

			// Define modal properties
			buttons = modal.data('buttons');

			// Define DOM elements
			header = modal.find('.modal-dialog-header');
			content = modal.find('.modal-dialog-content');
			footer =  modal.find('.modal-dialog-actions');
			iframe = modal.find('iframe');

			// Define helper methods
			updateDialog = function() {
				var max_height, modal_height, header_height, footer_height, iframe_height;

				iframe.css('height', 'auto');

				// Force css reset before measuring native iframe height
				setTimeout(function() {
						modal_height = modal.height();
						header_height = header.outerHeight();
						footer_height = footer.outerHeight();
						iframe_height = iframe.contents().outerHeight();

						max_height = modal_height - header_height - footer_height;
						iframe_height = (iframe_height < max_height) ? iframe_height : max_height;

						content.css('max-height', max_height + 'px');
						iframe.css('height', iframe_height + 'px');
				}, 0);
			};

			for (var i = 0; i < buttons.length; i++) {
				var button, callback, el, fn;

				button = buttons[i];
				callback = button.callback || function() {};
				el = modal.find('[data-action="callback-' + i + '"]');

				fn = function(e) {
					Modal.hide();
					callback(true);
					e.preventDefault();
				}

				el.on('click', fn);
			}

			// Event handling
			iframe.on('load', updateDialog);
			$(window).on('resize.app-modal', updateDialog);
		}

		if (modal.data('type') == 'content') {
			var title, buttons, header, footer;

			// Define modal properties
			title = modal.data('title');
			buttons = modal.data('buttons');

			// Define DOM elements
			header = modal.find('.modal-dialog-header');
			footer =  modal.find('.modal-dialog-actions');

			for (var i = 0; i < buttons.length; i++) {
				var button, callback, el, fn;

				button = buttons[i];
				callback = button.callback || function() {};
				el = modal.find('[data-action="callback-' + i + '"]');

				fn = function(e) {
					Modal.hide();
					callback(true);
					e.preventDefault();
				}

				el.on('click', fn);
			}

			if (title.length === 0) { header.hide(); }
			if (buttons.length === 0) { footer.hide(); }
		}

		if (modal.data('type') == 'page') {
			var backCallback, stopPropagation;

			backCallback = function(e) {
				Modal.hide();
				e.preventDefault();
			};

			stopPropagation = function(e) {
				e.stopImmediatePropagation();
			}

			// Click events
			modal.find('button[data-action="back"]').on('click', backCallback);
			modal.find('.modal-dialog-content').on('click', stopPropagation);
			modal.on('click.app-modal', Modal.hide);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Left arrow key
				if(e.which == 37) { backCallback(e); }

				// Escape key
				if(e.which == 27) { backCallback(e); }
			});
		}

		// Add modal to DOM
		$('html').addClass('has-modal');

		modal.appendTo('body');
		setTimeout(function(){ modal.addClass('visible'); }, 0);

		// Update Modal object
		Modal.element = modal;

		// Call the onload method yo!
		if (modal.data('onload')) {
			modal.data('onload').call();
		}

		return modal;
	};

	Modal.hide = function() {
		if (typeof Modal.element == 'undefined') {
			return false;
		}

		var delay, modal;

		delay = 500;
		modal = $(Modal.element);

		$('html').removeClass('has-modal');
		$(window).off('.app-modal');
		$(document).off('.app-modal');

		modal.removeClass('visible');
		setTimeout(function(){
			// Remove modal from DOM
			modal.remove();

			// Clear Modal object
			Modal.element = null;

			// Request next modal in queue
			Modal.show();
		}, delay);

		return modal;
	}

	Modal.alert = function(options, fn) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "Alert!",
			message: "This is an alert message",
			confirmButton: "Okay"
		};

		fn = fn || function(){};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#app-notification-alert').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and callback
		modal.data('type', 'alert');
		modal.data('callback', fn);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	};

	Modal.confirm = function(options, fn) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "Confirmation!",
			message: "This is a confirmation message",
			confirmButton: "Okay",
			cancelButton: "Cancel",
			style: ''
		};

		fn = fn || function(){};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#app-notification-confirmation').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and callback
		modal.data('type', 'confirmation');
		modal.data('callback', fn);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	};

	Modal.content = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "",
			content: "",
			buttons: []
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#app-notification-content').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type, title, and buttons
		modal.data('type', 'content');
		modal.data('title', this.options.title);
		modal.data('buttons', this.options.buttons);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	Modal.window = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "",
			src: "",
			buttons: [
				{
					label: "Done"
				}
			]
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#app-notification-window').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and buttons
		modal.data('type', 'window');
		modal.data('buttons', this.options.buttons);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	Modal.page = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			content: "",
			backButton: "Back",
			onload: function() {}
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#app-notification-page').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type
		modal.data('type', 'page');
		modal.data('onload', this.options.onload);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	// Notification module
	var Notification = {};

	Notification.element = null;

	Notification.show = function(el) {
		if (typeof el == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 2000;
		notification = $(el);

		// Add notification to DOM
		$('html').addClass('has-notification');

		notification.appendTo('body');
		setTimeout(function(){ notification.addClass('visible'); }, 0);

		// Reset flash timer
		clearTimeout(window.flashNoticeTimer);
		window.flashNoticeTimer = setTimeout(Notification.hide, delay);

		// Update Notification object
		Notification.element = el;

		return el;
	};

	Notification.update = function(el) {
		if (typeof el == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 2000;
		notification = $(el);

		// Replace the notification
		$(Notification.element).replaceWith(notification.addClass('visible'));

		// Reset flash timer
		clearTimeout(window.flashNoticeTimer);
		window.flashNoticeTimer = setTimeout(Notification.hide, delay);

		// Update notification object
		Notification.element = el;

		return el;
	}

	Notification.hide = function() {
		if (typeof Notification.element == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 500;
		notification = $(Notification.element);

		$('html').removeClass('has-notification');
		$(window).off('.app-notification');
		$(document).off('.app-notification');

		notification.removeClass('visible');
		setTimeout(function(){ notification.remove(); }, delay);

		// Clear outstanding timers
		clearTimeout(window.flashNoticeTimer);

		// Clear Notification object
		Notification.element = null;

		return notification;
	}

	var flashNotice = function(options) {
		var source, template, html, notification, closeButton, dismissNotification;

		// Set defaults
		this.options = {
			style: "default",
			message: "This is an notification!"
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#giftbox-app-flash-notification').html().trim();
		template = Handlebars.compile(source);

		// Construct HTML
		html = $(template(this.options));

		// Define DOM elements
		notification = html;
		closeButton = html.find('[data-action="close"]');

		// Bind object & events
		//Notification.element = notification;
		dismissNotification = function(e) {
			Notification.hide();
			e.preventDefault();
		};

		closeButton.on('click', dismissNotification);

		// Repaint UI
		if (Notification.element != null) {
			Notification.update(notification);
		} else {
			Notification.show(notification);
		}
	}

	// Return object
	return {
		Modal: Modal,
		flashNotice: flashNotice,
	};

})();


var Vitafive = (function(){

	var subscription_id, subscription, product, variant, max_quantity, selected_vitamins, subtotal, savings, vitamins, elements, queue;

	product = window.product;
	variant = null;
	max_quantity = 5;
	selected_vitamins = [];
	subtotal = 0;
	savings = 0;
	vitamins = [];
	elements = {};
	queue = [];

	function productBySKU(sku) {
		for (var i = 0; i < window.vitamins.length; i++) {
			if (window.vitamins[i].sku == sku) {
				return window.vitamins[i];
			}
		}
	}

	function formatMoney(cents) {
		return '$' + (cents / 100);
	}

	function getParameterByName(name) {
		var regex, results;

		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		results = regex.exec(location.search);

		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	function getSubscription(subscription_id) {
		var url = 'https://vitafive.am-apps.com/subscription/id/' + subscription_id;
		$.ajax({
			type: 'GET',
			url: url,
			data: {
				shop: 'vitafive.myshopify.com'
			},
			async: true,
			crossDomain: true,
			dataType: 'jsonp',
			success: function(json) {
                console.log(json);
				subscription = json;
			}
		});
	}

	function getPackName() {
		var pack_name = null;

		if (subscription) {
			for (var i = 0; i < subscription.properties.length; i++) {
				if (subscription.properties[i].name == 'pack_name') {
					pack_name = subscription.properties[i].value;
					break;
				}
			}
		}

		return pack_name;
	}

	function preloadImages() {
		for (var i = 0; i < window.vitamins.length; i++) {
			var img = new Image();

			img.src = window.vitamins[i].info_src;
			window.vitamins[i].cached_image = img;
		}
	}

	function unsavedChanges() {
		return 'If you leave this page, your personalized pack will be lost. Are you sure you want to leave this page?';
	}

	function addItem(sku) {
		if (selected_vitamins.length < max_quantity) {
			var vitamin = productBySKU(sku);

			selected_vitamins.push(vitamin);
			increaseWidgetQuantity(sku);
			updateUI();
		} else {
			alert('You can only select up to five vitamins.');
		}
	}

	function removeItem(sku) {
		for (var i = selected_vitamins.length - 1; i >= 0; i--) {
			if (selected_vitamins[i].sku == sku) {
				selected_vitamins.splice(i, 1);
				decreaseWidgetQuantity(sku);
				updateUI();
				break;
			}
		}
	}

	function increaseWidgetQuantity(sku) {
		var widget, quantity;

		widget = $('.vitamin .buttons[data-product-sku="' + sku + '"]');
		quantity =  widget.data('quantity') ? widget.data('quantity') : 0;

		quantity += 1;

		widget.data('quantity', quantity);
		$('.quantity', widget).html(quantity);

		if (quantity > 0) {
			widget.removeClass('no-quantity');
		}
	}

	function decreaseWidgetQuantity(sku) {
		var widget, quantity;

		widget = $('.vitamin .buttons[data-product-sku="' + sku + '"]');
		quantity =  widget.data('quantity') ? widget.data('quantity') : 0;

		quantity -= 1;

		widget.data('quantity', quantity);
		$('.quantity', widget).html(quantity);

		if (quantity == 0) {
			widget.addClass('no-quantity');
		}
	}

	function updateSubtotalAndSavings() {
		var premium_count, regular_count, variant_title;

		premium_count = 0;
		regular_count = 0;
		variant_title = '';

		// Calculate premium and regular counts
		for (var i = 0; i < selected_vitamins.length; i++) {
			if (selected_vitamins[i].premium) {
				premium_count += 1;
			} else {
				regular_count += 1;
			}
		}

		// Create variant title string for matching
		if (premium_count == 0) {
			// Do nothing
		}
		else if (premium_count == 1) {
			variant_title += premium_count + ' Premium Vitamin'
		}
		else if (premium_count > 1) {
			variant_title += premium_count + ' Premium Vitamins'
		}

		if (variant_title != '' && regular_count > 0) {
			variant_title += ' + '
		}

		if (regular_count == 0) {
			// Do nothing
		}
		else if (regular_count == 1) {
			variant_title += regular_count + ' Regular Vitamin'
		}
		else if (regular_count > 1) {
			variant_title += regular_count + ' Regular Vitamins'
		}

		for (var i = 0; i < product.variants.length; i++) {
			if (product.variants[i].title == variant_title) {
				variant = product.variants[i];
			}
		}

		subtotal = variant.price;
		savings = (variant.compare_at_price) ? (variant.compare_at_price - variant.price) : 0;
	}

	function updateSelectedTray() {

		for (var i = 0; i < selected_vitamins.length; i++) {
			var slot, vitamin;

			slot = elements.slots[i];
			vitamin = selected_vitamins[i];

			$('.image', slot).html('<img src="' + vitamin.image + '" />');
			$('.title', slot).html(vitamin.title);
		}

		for (var i = max_quantity - 1; i >= selected_vitamins.length; i--) {
			var slot = elements.slots[i];

			$('.image', slot).html('');
			$('.title', slot).html('');
		}

	}

	function updateUI() {
		updateSubtotalAndSavings();
		updateSelectedTray();

		if (selected_vitamins.length > 0) {
			window.onbeforeunload = unsavedChanges;
		} else {
			window.onbeforeunload = function(){};
		}

		$('#vitamin-total').html(formatMoney(subtotal));
		$('#vitamin-savings').html(formatMoney(savings));
	}

	function addToCart() {
		if (queue.length) {
			var product, data;

			product = queue.shift();
			data = {
				id: product.variants[0].id,
				quantity: 1
			};

			$.ajax({
				url: '/cart/add.js',
				dataType: 'json',
				type: 'post',
				data: data,
				success: function(product) {
					addToCart();
				},
				error: function(XMLHttpRequest) {
				}
			});

		} else {
			window.location = '/cart';
		}
	}

	function checkout() {
    console.log("checkout heard");
		var data, consolidated_array, properties = {};

		// Check for at least one vitamin
		if (selected_vitamins.length == 0) {
			alert('You must add at least on vitmain to your Personalized Pack before checking out.');
			return false;
		}

		// Update button
		var label = elements.checkout.find('span');

		elements.checkout.addClass('working');
		label.html(label.data('label-working'));

		// Remove any messaging
		window.onbeforeunload = function(){};

		// Consolidate vitamins
		consolidated_array = [];
		for (var i = 0; i < selected_vitamins.length; i++) {
			var match, vitamin;

			match = false;
			vitamin = selected_vitamins[i];

			// Find match
			for (var x = 0; x < consolidated_array.length; x++) {
				if (consolidated_array[x].sku == vitamin.sku) {
					match = vitamin;
					break;
				}
			}

			// Update array
			if (match) {
				match.quantity += 1;
			} else {
				vitamin.quantity = 1;
				consolidated_array.push(vitamin);
			}
		}

		// SKU Properties
		properties['_skus'] = '';
		for (var i = 0; i < selected_vitamins.length; i++) {
			if (properties['_skus'] != '') {
				properties['_skus'] += ',';
			}
			properties['_skus'] += selected_vitamins[i].sku;
		}

		// Pack Content Properties
		properties['pack_contents'] = '';
		for (var i = 0; i < consolidated_array.length; i++) {
			if (properties['pack_contents'] != '') {
				properties['pack_contents'] += ', ';
			}
			properties['pack_contents'] += (consolidated_array[i].quantity + ' x ' + consolidated_array[i].title);
		}

		// Custom Pack Name
		properties['pack_name'] = getPackName();

		// ReCharge Properties
		properties['subscription_id'] = '94262';
		properties['shipping_interval_frequency'] = '28';
		properties['shipping_interval_unit_type'] = 'Days';

		if (subscription_id) {
			// Define post object
			data = {
				id: subscription_id,
				shopify_product_id: product.id,
				shopify_variant_id: variant.id,
				product_title: product.title,
				variant_title: variant.title,
				price: (variant.price / 100),
				properties: properties,
				quantity: 1,
				shop: 'vitafive.myshopify.com',
			}

			var url = 'https://vitafive.am-apps.com/subscription/edit';
			$.ajax({
				type: 'POST',
				url: url,
				//data: data,
				data: {
					id: subscription_id,
					shopify_product_id: product.id,
					shopify_variant_id: variant.id,
					product_title: product.title,
					variant_title: variant.title,
					price: (variant.price / 100),
					properties: properties,
					quantity: 1,
					shop: 'vitafive.myshopify.com'
				},
				dataType: 'json',
				async: true,
				crossDomain: true,
				success: confirmUpdate,
				error: updateError
			});
		} else {
			// Define post object
			data = {
				id: variant.id,
				quantity: 1,
				properties: properties
			};

			// Add item to the cart
			$.ajax({
				url: '/cart/add.js',
				dataType: 'json',
				type: 'post',
				data: data,
				success: function(product) {
					// Update button
					var label = elements.checkout.find('span');

					elements.checkout.removeClass('working');
					label.html(label.data('label'));

					
						redirectToReCharge();
					
				},
				error: function(XMLHttpRequest) {
				}
			});
		}
	}

	function confirmUpdate(response) {
		// Update button
		var label = elements.checkout.find('span');

		elements.checkout.removeClass('working');
		label.html(label.data('label'));

		// Message the user
		setTimeout(function() {
			alert('Yay! We\'ve updated your Personalized Pack as requested.  You\'re all set!');
			window.location = '/account';
		});
	}

	function updateError(responseData, textStatus, errorThrown) {
		// Update button
		var label = elements.checkout.find('span');

		elements.checkout.removeClass('working');
		label.html(label.data('label'));

		// Update the user
		setTimeout(function() {
			alert('We were unable to update your subscription. Please try again. If you continue to experience this issue, please contact us at hello@vitafive.com.');
		});
	}

	function showMoreInfo(e) {
		var el, vitamin;

		el = $(this);
		vitamin = productBySKU(el.data('product-sku'));

		// Update image
		elements.modal.find('img').attr('src', vitamin.cached_image.src);

		// Append to body
		elements.modal.appendTo('body');

		// Display modal
		setTimeout(function() {
			elements.html.addClass('has-modal');
			elements.modal.addClass('visible');
		}, 10);

		if (typeof e != 'undefined') {
			e.preventDefault();
		}
	}

	function hideMoreInfo(e) {
		// Update image source
		elements.modal.find('img').attr('src', '');

		// Hide modal
		elements.html.removeClass('has-modal');
		elements.modal.removeClass('visible');

		// Detach modal
		setTimeout(function() {
			elements.modal.detach();
		}, 500);

		if (typeof e != 'undefined') {
			e.preventDefault();
		}
	}

	function getReChargeCookie(name) {
		return (document.cookie.match('(^|; )' + name + '=([^;]*)')||0)[2];
	}

	function redirectToReCharge() {
		var myshopify_domain, token, ga_linker, customer_param;

		myshopify_domain = 'vitafive.myshopify.com';
		token = getReChargeCookie('cart');

		try {
			// Cross-domain tracking with Google Analytics
			ga_linker = ga.getAll()[0].get('linkerParam');
		} catch (e) {
			// 'ga' is not available
			ga_linker = '';
		}

		// Customer email address for use in the Checkout URL
		customer_param = '';

		if (window.customer) {
			customer_param += 'customer_id=' + window.customer.id;
			customer_param += '&customer_email=' + window.customer.email;
		}

		// Build checkout URL
		checkout_url = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker + '&' + customer_param

		window.location = checkout_url;
	}

	function init() {

		elements.html = $('html');
		elements.slots = $('.selected-vitamins li');
		elements.checkout = $('.subtotal-button .add-to-cart');
		elements.plus_buttons = $('.vitamin .buttons .btn.plus');
		elements.minus_buttons = $('.vitamin .buttons .btn.minus');
		elements.info = $('.vitamin .more-info');
		elements.modal = $('#more-information-modal');
		elements.modal_close = $('#more-information-modal .modal-close');
		elements.modal_content = $('#more-information-modal .modal-content');

		elements.checkout.on('click', checkout);

		elements.plus_buttons.on('click', function(){
			var widget = $(this).closest('.buttons');
			addItem(widget.data('product-sku'));
		});

		elements.minus_buttons.on('click', function(){
			var widget = $(this).closest('.buttons');
			removeItem(widget.data('product-sku'));
		});

		elements.info.on('click', showMoreInfo);
		elements.modal.on('click', hideMoreInfo);
		elements.modal_close.on('click', hideMoreInfo);
		elements.modal_content.on('click', function(e) { e.stopImmediatePropagation(); });

		elements.modal.detach();

		// Check for subscription ID
		if (getParameterByName('id')) {
			subscription_id = getParameterByName('id');
			elements.checkout.html($('<span data-label="Update" data-label-working="Updating...">Update</span>'));

			// Get a copy of the subscription
			subscription = getSubscription(subscription_id);
		}

		// Check for SKUs
		if (getParameterByName('skus')) {
			var skus = getParameterByName('skus').split(',');

			for (var i = 0; i < skus.length; i++) {
				var vitamin = productBySKU(skus[i]);

				if (vitamin) {
					selected_vitamins.push(vitamin);
					increaseWidgetQuantity(skus[i]);
				}
			}

			// Update the UI
			updateUI();
		}

		// Preload images
		preloadImages();
	}

	return {
		init: init,
		vitamins: vitamins,
        redirectToReCharge: redirectToReCharge
	};
})();


var VitafiveCustomer = {
	getSubscriptions: function(callback) {
		var url = 'https://vitafive.am-apps.com/customer/id/' + window.customer.id;

		$.ajax({
			type: 'GET',
			url: url,
			data: {
				shop: 'vitafive.myshopify.com'
			},
			async: true,
			crossDomain: true,
			dataType: 'jsonp',
			success: function(json) {

				window.subscriber = json;
				VitafiveCustomer.displaySubscriptions();

				if (typeof callback == 'function') {
					callback();
				}
			},
			error: function(response) {
			}
		});
	},
	subscriptionByID: function(id) {
		var subscription;

		for (var i = 0; i < window.subscriber.subscriptions.length; i++) {
			if (window.subscriber.subscriptions[i].id == id) {
				subscription = window.subscriber.subscriptions[i];
				break;
			}
		}

		return subscription;
	},
	formatDate: function(date) {
		if (date) {
			var months, timestamp, month, day, year;

			months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

			timestamp = new Date(date);
			month = timestamp.getUTCMonth();
			day = timestamp.getUTCDate();
			year = timestamp.getUTCFullYear();

			return months[month] + ' ' + day + ', ' + year;
		} else {
			return '';
		}
	},
	canSkip: function(date) {
		if (date) {
			var max_days, now, next_shipment, max;

			max_days = 90;

			now = new Date();
			next_shipment = new Date(date);

			max = new Date(now);
			max.setDate(max.getDate() + max_days);

			return next_shipment <= max;
		} else {
			return true;
		}
	},
	displaySubscriptions: function() {
		var source, template, html;

		source = $('#subscription-list-item').html().trim();
		template = Handlebars.compile(source);

		// Size image
		Handlebars.registerHelper('image', function(shopify_product_id) {

			var image, extension;

			for (var i = 0; i < window.all_products.length; i++) {
				var product = window.all_products[i];

				if (product.id == shopify_product_id) {
					image = product.featured_image;
					break;
				}
			}

			extension = image.split('.').pop();

			return image.replace('.' + extension, '_small.' + extension);
		});

		// Pack name
		Handlebars.registerHelper('pack_name', function(subscription) {
			// Default to product name
			var name = subscription.product_title;

			// Upgrade to custom name if applicable
			for (var i = 0, prop; i < subscription.properties.length; i++) {
				prop = subscription.properties[i];
				if (prop.name == 'pack_name') {
					if (prop.value != null && prop.value != '') {
						name = prop.value;
					}
				}
			}

			return name;
		});

		// Can a customer skip? Only if next charge is less than 90 days out
		Handlebars.registerHelper('canSkip', function(date) {
			return VitafiveCustomer.canSkip(date);
		});

		// Pack contents
		Handlebars.registerHelper('pack_contents', function(subscription) {
			var contents = '';


			// Property
			for (var i = 0; i < subscription.properties.length; i++) {
				var prop = subscription.properties[i];
				if (prop.name == 'pack_contents') {
					contents = prop.value;
				}
			}

			// Based off product name
			if (contents === '') {

				if (subscription.product_title) {
					var start, stop, substring;

					start = subscription.product_title.indexOf('(') + 1;
					stop = subscription.product_title.indexOf(')', start);
					substring = subscription.product_title.substring(start, stop);

					if (substring) {
						contents = substring;
					}
				}

			}

			// Add parentheses
			if (contents !== '') {
				contents = "(" + contents + ")";
			}

			return contents;
		});

		// Pack content URL parameters
		Handlebars.registerHelper('pack_contents_url', function(properties) {
			var params = '';

			for (var i = 0; i < properties.length; i++) {
				var prop = properties[i];
				if (prop.name == '_skus') {
					params = '&skus=' + encodeURIComponent(prop.value);
				}
			}

			return params;
		});

		// Is personalized pack
		Handlebars.registerHelper('personalized_pack', function(shopify_product_id) {
			var product_ids = [1541613092977, 490208428062];

			return (product_ids.indexOf(shopify_product_id) != -1);
		})

		// Box price
		Handlebars.registerHelper('money', function(price) {
			return '$' + price.toFixed(2) + '/mo';
		});

		// Subscription status
		Handlebars.registerHelper('isCanceled', function(status) {
			if (status == 'CANCELLED') {
				return status;
			}
		});

		// Next shipment date
		Handlebars.registerHelper('nextShipmentDate', function(date) {
			if (date) {
				return '<i class="fa fa-truck"></i> Next shipment: ' + VitafiveCustomer.formatDate(date);
			} else {
				return '';
			}
		});

		html = template(window.subscriber);

		$('.subscription-list-contents').html(html);

		return new Handlebars.SafeString(html);
	},
	skipNextShipment: function(e) {
		var button, id, title, skip, getSubscriptions, confirmUpdate, updateError;

		button = $(this);
		id = button.data('subscription-id');
		title = button.data('product-title');
		label = button.find('span');
		skip = confirm('Are you sure you want to skip your next shipment?');

		confirmUpdate = function(response) {
			// Reload subscriptions & update button
			VitafiveCustomer.getSubscriptions(function(){
				button.removeClass('working');
				label.html(label.data('label'));
			});

			// Alert the user
			setTimeout(function(){
				alert('Your next shipment has been skipped! ' + title + ' will ship again on ' + VitafiveCustomer.formatDate(response.next_charge_scheduled_at) + '.');
			});
		};

		updateError = function(responseData, textStatus, errorThrown) {
			// Update button
			button.removeClass('working');
			label.html(label.data('label'));

			// Alert the user
			setTimeout(function(){
				alert('We were unable to update your subscription. Please try again. If you continue to experience this issue, please contact us at hello@vitafive.com.');
			});
		}

		if (skip == true) {
			// Update button
			button.addClass('working');
			label.html(label.data('label-working'));

			var url = 'https://vitafive.am-apps.com/subscription/skip';
			$.ajax({
				type: 'POST',
				url: url,
				data: {
					id: id,
					shop: 'vitafive.myshopify.com'
				},
				dataType: 'json',
				async: true,
				crossDomain: true,
				success: confirmUpdate,
				error: updateError
			});
		}

		if (typeof e != 'undefined') {
			e.preventDefault();
		}
	},
	editSubscriptionName: function(e) {
		var el, id, name, icon, subscription, source, template, html;

		//, confirmUpdate, updateError;

		el = $(this);
		id = el.data('subscription-id');
		name = el.data('pack-name');
		icon = el.find('i.fa');
		subscription = VitafiveCustomer.subscriptionByID(id);
		source = $('#custom-pack-name').html().trim();
		template = Handlebars.compile(source);

		// Pack name
		Handlebars.registerHelper('pack_name', function(subscription) {
			// Default to product name
			var name = subscription.product_title;

			// Upgrade to custom name if applicable
			for (var i = 0, prop; i < subscription.properties.length; i++) {
				prop = subscription.properties[i];
				if (prop.name == 'pack_name') {
					if (prop.value != null && prop.value != '') {
						name = prop.value;
					}
				}
			}

			return name;
		});

		html = template(subscription);

		var updatePackName, confirmUpdate, updateError;

		// Update pack name
		updatePackName = function(name) {

			// Extend subscription with new pack_name property
			var properties = {};

			for (var i = 0, prop; i < subscription.properties.length; i++) {
				prop = subscription.properties[i];
				properties[prop.name] = prop.value;
			}

			properties['pack_name'] = name;

			// Animate icon
			el.addClass('disabled');
			icon.addClass('fa-circle-o-notch fa-spin');

			var url = 'https://vitafive.am-apps.com/subscription/rename';
			$.ajax({
				type: 'POST',
				url: url,
				data: {
					id: id,
					shop: 'vitafive.myshopify.com',
					properties: properties
				},
				dataType: 'json',
				async: true,
				crossDomain: true,
				success: confirmUpdate,
				error: updateError
			});
		};

		// Update -- success
		confirmUpdate = function(response) {
			VitafiveCustomer.getSubscriptions();
		};

		// Update -- error
		updateError = function(responseData, textStatus, errorThrown) {
			// Alert the user
			setTimeout(function(){
				alert('We were unable to update your pack name. Please try again. If you continue to experience this issue, please contact us at hello@vitafive.com.');
			});

			// Remove icon animation
			el.removeClass('disabled');
			icon.removeClass('fa-circle-o-notch fa-spin');
		};


		App.Modal.content({
			title: 'Add a Custom Name',
			content: html,
			buttons: [
				{
					label: 'Cancel',
					style: 'btn--secondary btn--outline',
					callback: function(){
					}
				},
				{
					label: 'Update Name',
					style: 'btn--secondary',
					callback: function() {
						updatePackName($('#custom-name').val());
					}
				},
			]
		});


		if (typeof e != 'undefined') {
			e.preventDefault();
		}
	},
	init: function() {

		// Load subscriptions
		VitafiveCustomer.getSubscriptions();

		// Skip subscription shipment
		$('.subscription-list').on('click', '.skip-shipment', VitafiveCustomer.skipNextShipment);

		// Edit subscription name
		$('.subscription-list').on('click', '.edit-name', VitafiveCustomer.editSubscriptionName);
	}
};

$(function(){
	if ($('body#custom-4-week-supply').length == 1) {
		Vitafive.init();
	}

	if ($('body#account').length == 1) {
		VitafiveCustomer.init();
	}
});

Vitafive.init();
